import Vue from 'vue'
import User from '@/api/actions/user';
import Run from '@/api/actions/run';
import DeviceInfo from '@/api/actions/deviceInfo';
import ExerciseDocuments from '@/api/actions/exerciseDocuments';

Vue.mixin({
  beforeCreate() {
    const options = this.$options;
    if (options.api) this.$api = options.api;
    else if (options.parent && options.parent.$api) this.$api = options.parent.$api
  }
})

class Api {
  constructor(store, i18n) {
    this.store = store;
    this.i18n = i18n;
    // add RestModels here for all Requests
    this.user = new User(store);
    this.run = new Run(store);
    this.deviceInfo = new DeviceInfo(store);
    this.exerciseDocuments = new ExerciseDocuments(store);
  }
}

export default Api
